import { strings } from '../localization/strings';

const employeeRoleLabels: Record<string, string> = {
  admin: strings.employees.roles.admin,
  contentmanager: strings.employees.roles.contentmanager,
  manager: strings.employees.roles.manager,
  editor: strings.employees.roles.editor,
  photoeditor: strings.employees.roles.photoeditor,
  translator: strings.employees.roles.translator,
  photographer: strings.employees.roles.photographer,
  journalist: strings.employees.roles.journalist,
  'journalist-junior': strings.employees.roles.journalistJunior,
};

export const getEmployeeRoleLabel = (roleName: string): string => {
  return employeeRoleLabels[roleName] ?? roleName;
};
